export const CLOCKING_RECORDS_DEMO_ORG_ID = 'org-demo-001';

/** シード未ロード時の年月表示フォールバック（実データは 2026-03 付近） */
export const CLOCKING_RECORDS_FALLBACK_YEAR_MONTH = '2026-03';

/** Dexie seed と一致する勤務地（フィルタ UI 用） */
export const CLOCKING_RECORDS_DEMO_WORKPLACES = ['本社オフィス', '大阪支社', 'リモート拠点'] as const;